var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 39,
    viewBox: "0 0 44 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5459 0C35.2933 0 44 8.775 44 19.5C44 30.225 35.2933 39 24.5459 39C17.7244 39 11.758 35.451 8.27915 30.0885L10.3714 28.0655C13.1117 32.531 18.9682 36.2644 24.5654 36.2644C28.6889 36.2644 33.5414 34.4599 36.4571 31.5343C39.3729 28.6087 41.4857 23.6374 41.4857 19.5C41.4857 15.3626 39.3729 10.4938 36.4571 7.56823C33.5414 4.64266 28.6889 2.52274 24.5654 2.52274C16.636 2.52274 9.23145 9.867 8.27915 17.55H14.5177L7.24912 24.8235L0 17.55H5.22792C6.19965 7.7025 14.4788 0 24.5459 0ZM30.2986 16.068C31.2703 16.0875 32.0671 16.8675 32.0671 17.862V26.8515C32.0671 27.8265 31.2703 28.6455 30.2792 28.6455H19.5318C18.5406 28.6455 17.7438 27.8265 17.7438 26.8515V17.862C17.7438 16.8675 18.5406 16.0875 19.5124 16.068V14.0985C19.5124 11.115 21.9417 8.697 24.8958 8.697C27.8693 8.697 30.2986 11.115 30.2986 14.0985V16.068ZM24.8958 11.427C23.4382 11.427 22.2332 12.6165 22.2332 14.0985V16.068H27.5777V14.0985C27.5777 12.6165 26.3728 11.427 24.8958 11.427Z",
    fill: "url(#paint0_linear_172_5304)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_172_5304",
    x1: 8.48571,
    y1: 3.15343,
    x2: 37.1946,
    y2: 35.8535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E4C90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22BDE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPass);
export default __webpack_public_path__ + "static/media/reset-pass.56dfbaa8.svg";
export { ForwardRef as ReactComponent };